import React, { useState, useCallback } from "react";
import TabPanel, { Item } from "devextreme-react/tab-panel";
import ApprovalStatusBar from "../../../Components/OrderComponents/approvelStatusBar";
import useGetTrackPackage from "../../../Hooks/useGET/useGetTrackPackage";
import HistoryTab from "./TabComponents/historyTab";
import ItemsTab from "./TabComponents/itemsTab";
import DocumentsTab from "./TabComponents/documentsTab";
import TrackingTab from "./TabComponents/trackingTab";
import { Button } from "devextreme-react";
import DenyOrders from "../../../Components/DenyOrders/denyOrders";
import { getUserId } from "../../../Utils/helper";
import CommentTab from "./TabComponents/commentTab";

function DetailTemplate({ orderData, setNotifications, mutate }) {
  const trackingNumber = orderData?.vendors[0]?.trackingNumber;

  const [showPopup, setPopup] = useState({
    orderDeny: null,
  });
  const newStatus = orderData.status > 9 && orderData.status !== 15;
  const handleClose = (popupKey) => {
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: null,
    }));
  };
  const handlePopup = useCallback((popupKey, data) => {
    console.log("handlePopup data", data);
    setPopup((prevState) => ({
      ...prevState,
      [popupKey]: { data },
    }));
  }, []);
  console.log("order data", orderData);
  return (
    <>
      {showPopup.orderDeny && (
        <DenyOrders
          orderId={showPopup.orderDeny.data}
          setNotifications={setNotifications}
          onClose={() => handleClose("orderDeny")}
        />
      )}
      {/* {orderData?.vendors?.length > 1 &&
        orderData?.vendors[0]?.trackingNumber && (
          <h5>
            <span className="noBold label label-warning">
              {`Currently tracking "${orderData.vendors[0].name}: ${orderData.vendors[0].trackingNumber}". 
                    Manually track your other tracking number(s).`}
            </span>
          </h5>
        )} */}
      <div className="div-button">
        <Button
          id="deny-button"
          type="danger"
          onClick={() => handlePopup("orderDeny", orderData.id)}
          text="Deny"
          visible={
            orderData.status != 10 &&
            getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da" //vivible only to Kristen
          }
        />
      </div>
      <div className="order-status-bar">
        <ApprovalStatusBar
          data={orderData}
          // status={tracking?.status?.id}
          setNotifications={setNotifications}
          mutate={mutate}
        />
        {orderData.status !== 3 && orderData.status !== 4 && !newStatus && (
          <div
            className={`tracking-available-badge ${
              orderData?.vendors[0]?.trackingNumber
                ? "has-tracking"
                : "no-tracking"
            }`}
          >
            Tracking Available
          </div>
        )}
      </div>
      <TabPanel>
        <Item title="Items" render={() => ItemsTab(orderData.vendors)} />
        <Item title="History" render={() => HistoryTab(orderData.history)} />
        <Item
          title="Tracking"
          render={() => TrackingTab(orderData?.vendors)}
          disabled={orderData?.vendors[0]?.trackingNumber ? false : true}
        />
        <Item title="Documents" render={() => DocumentsTab(orderData.id)} />
        <Item title="Comments" render={() => CommentTab(orderData.id)} />
      </TabPanel>
    </>
  );
}

export default DetailTemplate;
